function setupFamilySelectorInput() {
    familySelectorInput = document.getElementById('product-family');
    if (familySelectorInput) {
        var optionTextArrays = [];
        var firstOptionTextArray = [];
        var optionTextArraysCount = 0;
        for (var option of familySelectorInput.options) {
            var textArray = option.text.split(' ');
            if (optionTextArraysCount == 0) {
                firstOptionTextArray = textArray;
            } else {
                optionTextArrays.push(textArray);
            }
            optionTextArraysCount++;
        }
        var totalWordMatchArray = [];
        for (var optionTextArray of optionTextArrays) {
            var optionTextArrayCount;
            for (optionTextArrayCount = 0; optionTextArrayCount < optionTextArray.length; optionTextArrayCount++) {
                var optionText = optionTextArray[optionTextArrayCount].replace(/[^\w\s]/gi, '');
                var firstOptionText = firstOptionTextArray[optionTextArrayCount].replace(/[^\w\s]/gi, '');
                if (optionText !== firstOptionText) {
                    totalWordMatchArray.push(optionTextArrayCount);
                    break;
                }
            }
        }
        totalWordMatchArray.sort((a, b) => a - b)
        var totalWordMatch = totalWordMatchArray[0];
        for (var option of familySelectorInput.options) {
            var textArray = option.text.split(' ');
            for (shiftArrayCount = 0; shiftArrayCount < totalWordMatch; shiftArrayCount++) {
                textArray.shift();
            }
            var newOptionString = '';
            for (var text of textArray) {
                newOptionString = newOptionString.concat(text + ' ');
            }
            newOptionString = newOptionString.replace(/^— /gi, '');
            option.innerHTML = newOptionString;
        }
        familySelectorInput.addEventListener('change', (event) => {
            var targetURL = event.target.value;
            if (targetURL !== null) {
                window.location.href = targetURL;
            }
        });
    }
}

setupFamilySelectorInput();